<template>
  <div>
    <!-- 教育培训详情 -->
    <div class="center-intro">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "./../../../common/minix.less";
.wrapper{
    font-size: 24/@rem;
}
.center-intro {
  width: 100%;
  padding: 20/@rem;
  box-sizing: border-box;
  background: #F2F2F2;
}

</style>
<script>
import itemDetail from "@/components/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      detail: {}
    };
  },
  mounted() {
    if (this.$route.query.flag == 1) {
      this.secondTitle("教育培训");
    }else{
         this.secondTitle("人才招聘");
    }
    this.getDetail();
  },
  methods: {
    ...mapActions(["firstTitle", "secondTitle"]),
    getDetail() {
      userApi.getpersonDeatil({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    itemDetail
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Personnel/Children/detail.vue